import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import type { RowDraft } from "../roster.schemas";
import type { RosterUser } from "../roster.types";
import { RosterRow } from "./RosterRow";

export function RosterTable({
  users,
  draftFor,
  onDraftChange,
}: {
  users: RosterUser[];
  draftFor: (user: RosterUser) => RowDraft;
  onDraftChange: (userId: string, next: RowDraft) => void;
}) {
  return (
    // w-auto overrides the primitive's w-full so the table sizes to its content.
    <Table className="w-auto [&_td]:px-4 [&_th]:px-4">
      <TableHeader>
        <TableRow>
          <TableHead>Username</TableHead>
          <TableHead>Display name</TableHead>
          <TableHead>Rank</TableHead>
          <TableHead>Characters</TableHead>
          <TableHead className="w-10" />
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <RosterRow
            key={user.id}
            user={user}
            draft={draftFor(user)}
            onDraftChange={onDraftChange}
          />
        ))}
      </TableBody>
    </Table>
  );
}
